import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { EMPTY, Observable } from 'rxjs';
import { catchError, retry, shareReplay } from 'rxjs/operators';
import { ConfigService } from '../services/config.service';
import { CandidateNote, CandidateNoteDTO } from '../shared/models/candidateNote';

@Injectable({
    providedIn: 'root'
})
export class InternNoteService {

    headers = new HttpHeaders({ 'Content-Type': 'application/json' });
    apiUrl = '';

    constructor(private httpClient: HttpClient, private configSvc: ConfigService) {
        this.apiUrl = this.configSvc.apiUrl;
        console.log("APIURL from Environment is as follows:");
        console.log(this.apiUrl);
    }

    public GetInternNotes(InternID: number) {
        return this.httpClient.get<CandidateNoteDTO[]>(`${this.apiUrl}/Notes/${InternID}`).pipe(
            retry(3),
            catchError(error => {
                console.log(error);

                return EMPTY;
            }),
            shareReplay()
        );
    }

    public SetInternNote(bodyFormData: FormData) {
        return this.httpClient.put<CandidateNoteDTO>(`${this.apiUrl}/Note/update/`, bodyFormData).pipe(
            retry(0),
            catchError(error => {
                console.log(error);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    public CreateInternNote(note: CandidateNote) {
        return this.httpClient.post<any>(`${this.apiUrl}/Note/`, note).pipe(
            retry(0),
            catchError(error => {
                console.log(error);
                return EMPTY;
            }),
            shareReplay()
        );
    }

    public createInternContactNotes(requestPayload: any): Observable<any> {
        return this.httpClient.post<any>(`${this.configSvc.apiUrl}/intern-contact-notes`, requestPayload).pipe(
            catchError(error => {
                console.log(error);
                return EMPTY;
            })
        );
    }
}
